import { useCallback, useEffect, useRef } from 'react';

const THRESHOLD = 50;
export const useScrollBooleanToggle = (callback: (toggled: boolean) => void) => {
  const prevScrollY = useRef(0);

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;

    if (Math.abs(currentScrollY - prevScrollY.current) < THRESHOLD) {
      return;
    }

    callback(currentScrollY > prevScrollY.current);
    prevScrollY.current = currentScrollY;
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
};
